











































import {Vue, Prop, Component} from 'vue-property-decorator'
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';
import HomeViewModule from '../store/view/HomeViewModule';
import ITodoCollection, {ITodo} from '@/models/todoCollection';


@Component
export default class WhyDialog extends Vue {

    public get prompt() {
        return HomeViewModule.promptWhyDocumentDialog;
    }

    public closeWhyDialog() {
        HomeViewModule.loadPromptWhyDocumentDialog(false);
    }
	
}
